import { render, staticRenderFns } from "./WindyMap.vue?vue&type=template&id=74fa54b6"
import script from "./WindyMap.vue?vue&type=script&lang=js"
export * from "./WindyMap.vue?vue&type=script&lang=js"
import style0 from "./WindyMap.vue?vue&type=style&index=0&id=74fa54b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports